module.exports = __webpack_public_path__ + "images/culture-amp-logo-email-footer-9eabcc8df63aa09d4a59e6cd0508902b.png";